import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export function formatCount(count: number | null | undefined) {
  if (typeof count !== 'number' || isNaN(count)) return '0';
  return count > 1000 ? formatNumber(count) : count.toLocaleString();
}

export function formatNumber(num: number): string {
  if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(2).replace(/\.0$/, '') + 'M';
  } else if (num >= 1_000) {
    return (num / 1_000).toFixed(2).replace(/\.0$/, '') + 'K';
  } else if (num < 1_000 && num > 0) {
    return (num / 1_000).toFixed(2).replace(/\.0$/, '') + 'K';
  } else {
    return num.toString();
  }
}

export function toTitleCase(str: string): string {
  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase(),
  );
}

export function getCurrencySymbol(currencyCode: string): string {
  try {
    const formatter = new Intl.NumberFormat('en', {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: 'narrowSymbol',
    });
    const formatted = formatter.format(1);
    const match = formatted.match(/[^\d.,\s]/g);
    return match ? match.join('') : currencyCode;
  } catch (error) {
    return currencyCode;
  }
}

export function downloadCsvTemplate(columns: string[], filename: string): void {
  const csv = columns.map((c) => `"${c.replace(/"/g, '""')}"`).join(',') + '\n';
  const a = document.createElement('a');
  a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
  a.download = filename;
  a.click();
}

export function formatMediaType(type?: string | null): string {
  if (!type) return 'Unknown';

  const normalized = type.trim().toLowerCase();

  switch (normalized) {
    case 'image':
      return 'Image';
    case 'video':
      return 'Video';
    case 'album':
    case 'carousel_album':
    case 'carousel':
      return 'Carousel';
    case 'reel':
    case 'reels':
      return 'Reel';
    case 'story':
    case 'stories':
      return 'Story';
    case 'live_video':
    case 'live':
      return 'Live Video';
    default:
      return normalized.charAt(0).toUpperCase() + normalized.slice(1);
  }
}
